import React, {} from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import Dropdown from "../ui/Dropdown";
import {setCabinetGLBFromCabinetsSet} from "../../helpers/sqft3dArHelper";
import {setSQFTViewMode} from "../../../../actions/sqftFunctions";
import {prepareSQFTData} from "../canvas/core/workspace/workspaceDataMapper";
import workspace from "../canvas/core/workspace";
import {SQFT_VIEW_MODE} from "../../constants";

const SQFTModeDropdown = (props) => {
  const {setSQFTViewMode} = props;

  //TODO labels translation
  const items = [
    {label: "2d Mode", value: SQFT_VIEW_MODE.twoDMode},
    {label: "3d Mode", value: SQFT_VIEW_MODE.threeDMode},
    //{label: "3d Mode Doors", value: SQFT_VIEW_MODE.threeDModeDoors},
    {label: "Augmented Reality", value: SQFT_VIEW_MODE.augmentedReality},
    {label: "Augmented Reality Doors", value: SQFT_VIEW_MODE.augmentedRealityDoors},
  ];

  return (
    <Dropdown className={"dropdown-mode ui-select"}
              items={items}
              activeItemIndex={0}
              onItemSelect={async (item)=> {
                setSQFTViewMode(item.value);
                let sqftCalcData;
                switch (item.value) {
                  case SQFT_VIEW_MODE.threeDMode:
                  case SQFT_VIEW_MODE.augmentedReality:
                    await setCabinetGLBFromCabinetsSet().then(r => void r);
                    break;
                  case SQFT_VIEW_MODE.threeDModeDoors:
                  case SQFT_VIEW_MODE.augmentedRealityDoors:
                    await setCabinetGLBFromCabinetsSet(true).then(r => void r);
                    break;
                  case SQFT_VIEW_MODE.twoDMode:
                    sqftCalcData = await prepareSQFTData();
                    workspace.import(sqftCalcData);
                    break;
                }
              }}
              isOpenInitially={false}
    />
  )
}

SQFTModeDropdown.propTypes = {
};

const mapStateToProps = (store) => ({
  windowWidth: store.serverState.windowWidth,
})

const mapDispatchToProps = {
  setSQFTViewMode
}

export default injectIntl (
  connect(mapStateToProps, mapDispatchToProps)(SQFTModeDropdown)
);
